import { Spinner as ChakraSpinner, SpinnerProps } from "@chakra-ui/react";

const LoadingSpinner = ({ ...spinnerProps }: SpinnerProps) => (
  <ChakraSpinner size="xl" {...spinnerProps} />
);

export default LoadingSpinner;
